import { resolveUnitId } from './resolveUnitId';

/**
 * 1 個單位＝多少 base（base 自身為 1）。
 * 優先 convertRate／conversionRate；否則 toBaseNumerator／Denominator。
 *
 * @param {Array<object>|null|undefined} unitOptions
 * @param {string} [unitId]
 * @returns {number|null} 非法或找不到時 null
 */
export function resolveUnitToBaseRate(unitOptions, unitId) {
  const id = String(unitId ?? '').trim();
  if (!id) {
    return null;
  }

  const list = Array.isArray(unitOptions) ? unitOptions : [];
  const unit = list.find((row) => resolveUnitId(row) === id);
  if (!unit) {
    return null;
  }

  if (unit.baseUnit === true) {
    return 1;
  }

  const convertRate = Number(unit.convertRate ?? unit.conversionRate);
  if (Number.isFinite(convertRate) && convertRate > 0) {
    return convertRate;
  }

  const num = Number(unit.toBaseNumerator);
  const den = Number(unit.toBaseDenominator);
  if (Number.isFinite(num) && Number.isFinite(den) && den !== 0 && num > 0) {
    return num / den;
  }

  // 無換算資料時視為 base（與「無法換算」分開：呼叫端可再決定）
  return 1;
}
